var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F0414C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 11.5555C16.4909 11.5555 16.8888 11.9535 16.8888 12.4444V15.9999C16.8888 16.4909 16.4909 16.8888 15.9999 16.8888C15.509 16.8888 15.1111 16.4909 15.1111 15.9999V12.4444C15.1111 11.9535 15.509 11.5555 15.9999 11.5555Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 20.4444C16.4909 20.4444 16.8888 20.0464 16.8888 19.5555C16.8888 19.0646 16.4909 18.6666 15.9999 18.6666C15.509 18.6666 15.1111 19.0646 15.1111 19.5555C15.1111 20.0464 15.509 20.4444 15.9999 20.4444Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.22217 15.9999C6.22217 10.5998 10.5998 6.22217 15.9999 6.22217C21.4001 6.22217 25.7777 10.5998 25.7777 15.9999C25.7777 21.4001 21.4001 25.7777 15.9999 25.7777C10.5998 25.7777 6.22217 21.4001 6.22217 15.9999ZM15.9999 7.99995C11.5817 7.99995 7.99995 11.5817 7.99995 15.9999C7.99995 20.4182 11.5817 23.9999 15.9999 23.9999C20.4182 23.9999 23.9999 20.4182 23.9999 15.9999C23.9999 11.5817 20.4182 7.99995 15.9999 7.99995Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.d3c02a741cd944c12f2501e738824c13.svg";
export { ForwardRef as ReactComponent };